import { render, staticRenderFns } from "./scoreboard.vue?vue&type=template&id=e75925a8&"
import script from "./scoreboard.vue?vue&type=script&lang=js&"
export * from "./scoreboard.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports